<template>
  <div class="qrcode">
    <div class="title">
      <p class="on">登录</p>
      <p @click="setMode">注册</p>
    </div>
    <div class="con">
      <div class="qrcodeBox">
        <img src="" alt="" />
        <p>请使用微信扫描二维码登录</p>
      </div>
      <div class="text">
        <Agreement></Agreement>
      </div>
    </div>
  </div>
</template>

<script>
import Agreement from '@/components/login/agreement/agreement.vue'

export default {
  name: 'qrcode',
  data () {
    return {
      isHideFun: 'true'
    }
  },
  components: {
    Agreement
  },
  computed: {
    system () {
      return this.$store.state.getsystem.system
    }
  },
  methods: {
    BatchesFun (e) {
      this.isHideFun = e
    },
    // 改变登录注册模式
    setMode () {
      this.$store.dispatch('set_isLogin', false)
      this.$store.dispatch('set_isQrCode', true)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./qrcode";
</style>



// WEBPACK FOOTER //
// src/components/login/qrcode/qrcode.vue